var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from 'next-i18next';
import { TitleModalWrapper, Title, Reference } from './styles';
var TitleModal = function TitleModal(_ref) {
  var title = _ref.title,
    reference = _ref.reference;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(TitleModalWrapper, null, __jsx(Title, {
    dangerouslySetInnerHTML: title
  }), __jsx(Reference, null, t('Reference'), " ", reference));
};
export default TitleModal;